
























































































import Vue from 'vue';
import { auth } from 'firebase/app';
import SparkIcon from '@/assets/img/icons/lightning.svg';
import DreamIcon from '@/assets/img/icons/list-check.svg';
import AddNewIcon from '@/assets/img/icons/plus-circle.svg';
import ProfileIcon from '@/assets/img/icons/person-circle.svg';
import { MobileUtil } from '@/web/util/MobileUtil';

const mobileUtil = new MobileUtil(window.navigator.userAgent);

export default Vue.component('Navigation', {
  components: {
    SparkIcon,
    DreamIcon,
    AddNewIcon,
    ProfileIcon,
  },
  computed: {
    currentUser() {
      if (!this.$store.state.currentUser && auth().currentUser) {
        this.$store.commit('setCurrentUser', auth().currentUser);
      }
      return this.$store.state.currentUser;
    },
    showNav() {
      return this.$store.state.showNav;
    },
  },
  methods: {
    navClass(path: string): string {
      const exactPaths = ['/dreams/add'];
      const useExact = exactPaths.includes(this.$route.fullPath);
      const isActive = useExact ? this.$route.fullPath == path : this.$route.fullPath.startsWith(path);

      return isActive ? 'active' : 'inactive';
    },
    isMobile(): boolean {
      return mobileUtil.isMobile();
    },
    showAuthenticatedTopNav(): boolean {
      return this.showNav && this.currentUser && !this.isMobile();
    },
    showAuthenticatedBottomNav(): boolean {
      return this.showNav && this.currentUser && this.isMobile();
    },
    showUnauthenticatedTopNav(): boolean {
      return this.showNav && !this.currentUser;
    },
    navbarClass(): string {
      if (this.showAuthenticatedTopNav()) {
        return 'fixed-top navbar-top bg-light ';
      } else if (this.showAuthenticatedBottomNav()) {
        return 'fixed-bottom navbar-bottom bg-light ';
      } else if (this.showUnauthenticatedTopNav()) {
        return 'fixed-top navbar-top-white ';
      }
      return ' ';
    },
  },
});
